import { createElement } from '@vivaldis/common'
import { Container } from './components/Container'
import { ActionBarProps } from './typings/ActionBarProps'
import { LeftContentContainer } from './components/LeftContentContainer'
import { RightContentContainer } from './components/RightContentContainer'

const ActionBarBase = ({
  container = Container,
  leftContent,
  leftContentContainer = LeftContentContainer,
  rightContent,
  rightContentContainer = RightContentContainer
}: ActionBarProps) => {
  return createElement(
    container,
    undefined,
    <>
      {createElement(
        leftContentContainer,
        undefined,
        createElement(leftContent)
      )}
      {createElement(
        rightContentContainer,
        undefined,
        createElement(rightContent)
      )}
    </>
  )
}

export const ActionBar = Object.assign(ActionBarBase, { Container })
